// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('clientSettings', ['$http', 'obexConstant', 'authService',
    function($http, obexConstant, authService) {
      return {
        getOrganizationById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        updateOrganization(id, organization) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.put(url, organization, {
              headers: authHeader,
            });
          });
        },
        getWindowsTimeZones() {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlWindowsTimeZones}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/clientSettings.service.js